module.exports = __webpack_public_path__ + "components/flag/static/square/as-6cb44ade75e33c5fe9c2a11bc744070c.svg";